// extracted by mini-css-extract-plugin
export default {"ellipsis":"e0SeuGlM2mcpmgS3cUmH","wrapper":"NMrpOLwe1cAmLDOOhFlY","spin":"IT0y3j01RoEhlWgUZBwm"};